import React from "react";

import ChecklistSubtitle from "./Subtitle";
import ChecklistCheckbox from "./Checkbox";

const ChecklistBrandGols = ({ brandGols, handleClearGolsSelection, handleSelectByAudienceTargeting, totalSelected }) =>
  brandGols.map((gol) => (
    <section className="checklist-checkbox-section" key={gol.name}>
      <div className="checklist-checkbox-header">
        <ChecklistSubtitle subtitle="You can select up to 10 interest areas." totalSelected={totalSelected} />
        <button
          className="checklist-checkbox-clear-btn"
          type="button"
          onClick={() => handleClearGolsSelection(gol.name)}
        >
          Clear Selections <i className="fa-regular fa-circle-xmark" />
        </button>
      </div>
      <fieldset className="checklist-checkbox-fieldset" key={gol.name}>
        {gol.golBindings.map((binding) => (
          <ChecklistCheckbox
            key={binding.name}
            name={binding.name}
            label={binding.name}
            onChange={(e) => handleSelectByAudienceTargeting(binding.golId, e.target.checked, totalSelected)}
            checked={binding.checked}
          />
        ))}
      </fieldset>
    </section>
  ));

export default ChecklistBrandGols;
